import React from 'react';
import { Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';

import useProfile from '@src/hooks/useProfile';

// const goftinoUrl = 'https://goftino.com/c/20S8eL';
const supportId = '20S8eL';
const src = 'https://www.goftino.com/widget/';

const useGoftino = (tags?: string, onLoadCallback?: () => void) => {
  const navigation = useNavigation();
  const user = useProfile();
  const isWeb = React.useMemo(() => Platform.OS === 'web', []);
  let head: HTMLHeadElement;
  let scriptTag: HTMLScriptElement;

  if (isWeb) {
    const srcUrl = src + supportId;
    const data = window.localStorage.getItem('goftino_' + supportId);
    const source = data ? srcUrl + '?o=' + data : srcUrl;
    scriptTag = document.createElement('script');
    head = window.document.getElementsByTagName('head')[0];
    scriptTag.id = 'GOFTINO_' + supportId;
    scriptTag.src = source;
    scriptTag.async = true;

    console.log('source', scriptTag.getAttribute('widget-icon'));
  }

  const onLoad = React.useCallback(() => {
    window?.Goftino?.setUser({
      name: user?.name ?? user?.username,
      about: user?.bio,
      // phone: user?.,
      avatar: user?.avatar?.uri,
      tags,
      forceUpdate: true,
    });
    window?.Goftino?.setWidget({
      hasIcon: true,
      cssUrl: '../../assets/css/goftino.css',
      marginBottom: 0,
    });
    onLoadCallback && onLoadCallback();
  }, [onLoadCallback, tags, user]);

  const closeWidget = React.useCallback(() => {
    window?.Goftino?.close();
  }, []);

  const openWidget = React.useCallback(() => {
    window?.Goftino?.open();
  }, []);

  const hideWidget = React.useCallback(() => {
    window?.Goftino?.setWidget({ hasIcon: false });
  }, []);

  const showWidget = React.useCallback(() => {
    window?.Goftino?.setWidget({ hasIcon: true });
  }, []);

  navigation.addListener('focus', () => {
    if (isWeb) {
      window.addEventListener('goftino_ready', onLoad);
      head.appendChild(scriptTag);
      //showWidget();
    }
  });

  navigation.addListener('blur', () => {
    if (isWeb) {
      closeWidget();
    }
  });

  navigation.addListener('beforeRemove', () => {
    if (isWeb) {
      hideWidget();
    }
  });

  React.useEffect(() => {
    return () => {
      if (isWeb) {
        hideWidget();
      }
    };
  }, [hideWidget, isWeb]);

  return {
    open: openWidget,
    close: closeWidget,
  };
};

export default useGoftino;
